var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "simple-form" }, [
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [
          _c(
            "a",
            {
              staticClass: "ml10",
              staticStyle: { color: "blue" },
              on: { click: _vm.selectShopComnRepair }
            },
            [_vm._v("选择")]
          ),
          _vm._v(" "),
          _c("a", { staticClass: "ml10 fr" }, [
            _vm._v("已选择(" + _vm._s(_vm.shopComnRepairList.length) + ")")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-layout" },
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.shopComnRepairList,
                  border: "",
                  height: "250",
                  "tooltip-effect": "dark"
                }
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "title", label: "名称" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "servcCatName", label: "服务分类" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "creatorName", label: "创建人" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "postName", label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  _vm.deleteDevice(rows.row)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-value" },
        [
          _c("swb-shop-comn-repair-servicer", {
            ref: "swb_shop_device_servicer",
            attrs: {
              showRepair: _vm.showRepair,
              add: true,
              servcCatId: _vm.servcCatId
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label " }, [
      _c("label", { staticClass: "required" }, [_vm._v("常规服务项")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label " }, [
      _c("label", { staticClass: "required" }, [_vm._v("服务商")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2223ffbd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2223ffbd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/shopComnReq/ShopComnRepairServicerPageList.vue
// module id = 2372
// module chunks = 0